import { cloneElement, memo, useState } from 'react';

import { Badge, Button, Divider, Dropdown, Flex } from 'antd';

import { BellFilled } from '@ant-design/icons';

import EmptyPlaceholder from '../../views/ui-components/EmptyPlaceholder';

import './styles.scss';

function NotificationsDropdown({ count = 0, list, history }) {
  const [open, setOpen] = useState(false);

  const items = [
    {
      key: '1',
      label: <div className="d-flex no-block align-items-center py-2 px-3 bg-primary text-white">Notifications</div>
    },
    {
      key: '2',
      label: count > 0 ? <ul style={{ padding: 0, listStyle: 'none' }}>{list}</ul> : <EmptyPlaceholder />
    }
  ];

  const contentStyle = {
    backgroundColor: '#fff',
    boxShadow:
      '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
  };
  const menuStyle = {
    boxShadow: 'none'
  };

  const handleClickAllNotifications = () => {
    setOpen(false);
    history.push('/notifications');
  };

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      overlayClassName="header-dropdown no-hover"
      placement="bottomRight"
      trigger="click"
      menu={{ items }}
      popupRender={menu => (
        <div style={contentStyle}>
          {cloneElement(menu, { style: menuStyle })}
          <Divider style={{ margin: 0 }} />
          <div style={{ padding: '0.65rem 1rem' }}>
            <Button type="link" style={{ width: '100%' }} onClick={handleClickAllNotifications}>
              See all notifications
            </Button>
          </div>
        </div>
      )}>
      <Flex className="trigger" align="center" onClick={e => e.preventDefault()}>
        <Badge count={count} offset={[3, 0]} overflowCount={9}>
          <BellFilled style={{ color: 'rgba(0, 0, 0, 0.5)', fontSize: 18 }} />
        </Badge>
      </Flex>
    </Dropdown>
  );
}

export default memo(NotificationsDropdown);
